<div class="pds-table">
  <div class="pds-table__wrapper" [style.maxHeight.px]="height">
    <ng-content></ng-content>
  </div>
</div>
